import { PreferencesService } from './preferences.service';

export default angular
  .module('sfMobile.services.preferences', [
    'sfMobile.services.pov',
    'sfMobile.services.profile',
    'sfMobile.services.preferences',
  ])
  .service('preferencesService', PreferencesService).name;
